var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4DoNotDisturb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 21v6H35.79a3 3 0 01-3-3.56A3.1 3.1 0 0135.94 21H64zM49 46.48V67H24V21.18a12.62 12.62 0 0120.86-9.45A12.6 12.6 0 0148.47 17h-6.82a5.743 5.743 0 00-.73-.75 6.561 6.561 0 00-5.31-1.53A6.77 6.77 0 0030 21.51v3.56c0 3.08 1.41 6.83 7.85 8C45.77 34.88 49 40.79 49 46.48zm-9.73 6l4.27-4.28-2.83-2.8-4.27 4.27-4.28-4.27-2.83 2.82 4.28 4.28-4.28 4.27 2.83 2.83 4.28-4.27 4.27 4.27 2.83-2.83-4.27-4.29z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Do_not_disturb.a1db83e6.svg";
export { SvgE4DoNotDisturb as ReactComponent };